function cartIconBubble(){
    fetch('/')
     .then(response => {
       return response.text();
     })
    .then(responseHTML => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseHTML, 'text/html');
        const newBubble = doc.querySelector('#cart-icon-bubble');
        const currentBubble = document.querySelector('#cart-icon-bubble');
        if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
        }
    })
    .catch(err => console.error(err));
}

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  cartIconBubble();
});